import { SubscriptionEdit } from "./SubscriptionEdit";
import { SubscriptionsList } from "./SubscriptionsList";
import { Identifier } from "react-admin";
import AvTimerOutlinedIcon from "@material-ui/icons/AvTimerOutlined";
import { RecordStatus } from "../../../common/data/service-proxies";
import { SubscriptionCreate } from "./SubscriptionCreate";

export default {
  icon: AvTimerOutlinedIcon,
  list: SubscriptionsList,
  create: SubscriptionCreate,
  edit: SubscriptionEdit,
};

// TODO: Subscription costs
export interface SubscriptionListDto {
  id: Identifier;
  tenantName: string;
  startDate: Date;
  expirationDate: Date;
  isAutoRenew: boolean;
  isTrial: boolean;
  featureNames: Array<string>;
  rentedEldsCount: number;
  status: RecordStatus;
}

export interface SubscriptionDto {
  id: Identifier;
  tenantId: Identifier;
  startDate: Date;
  minDurationMonths: number;
  durationMonths: number;
  isAutoRenew: boolean;
  isTrial: boolean;
  featureIds: Array<Identifier>;
  rentedEldIds: Array<Identifier>;
  status: RecordStatus;
}
